/* styles.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._16jlkb7n{flex-grow:1}";
const _10 = "._syazwdcn{color:var(--ds-icon,#44546f)}";
const _9 = "._gy1ppxbi{column-gap:var(--ds-space-200,1pc)}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._19pkutpp{margin-top:var(--ds-space-150,9pt)}";
const _6 = "._19bvidpf{padding-left:0}";
const _5 = "._n3tdidpf{padding-bottom:0}";
const _4 = "._u5f3idpf{padding-right:0}";
const _3 = "._ca0qidpf{padding-top:0}";
const _2 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._iv8m1ejb:not(:last-of-type){margin-bottom:var(--ds-space-300,24px)}";
export const SubSection = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_iv8m1ejb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SubSection.displayName = 'SubSection';
}
export const ItemDescription = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyr1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ItemDescription.displayName = 'ItemDescription';
}
export const InfoList = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkutpp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InfoList.displayName = 'InfoList';
}
export const InfoListItem = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _gy1ppxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InfoListItem.displayName = 'InfoListItem';
}
export const InfoListItemIcon = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syazwdcn", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InfoListItemIcon.displayName = 'InfoListItemIcon';
}
export const InfoListItemContent = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InfoListItemContent.displayName = 'InfoListItemContent';
}